import React, {useRef} from 'react';
import OwlCarousel from "react-owl-carousel2";
import 'react-owl-carousel2/lib/styles.css';

const VerticalSlider = (props) => {
    const refSlider = useRef(null);

    const options = {
        items: 1,
        nav: true,
        loop: true,
        dots: false,
        center: true,
        lazyLoad:true,
        navText: [],
        lazyLoadEager: 1,
        mouseDrag: false,
        animateOut: 'fadeOut',
        responsive: {
            0: {
                items: 1,
                nav: true,
            },
            1024: {
                items: 1,
                nav: true,
            },
        }
    };

    const events = {
        onInitialized: () => {
            if (props.loading) {
                props.setLoading(false)
            }
        }
    }

    const item = {
        items: props.gallery.map(item => <div className="item" key={item}>
            <img src={item} alt="" />
        </div>)
    };

    return (
        <OwlCarousel
            ref={refSlider}
            options={options}
            events={events}
            touch-action="pan-y"
            className="owl-carousel owl-theme aparats_left"
        >{item.items}
        </OwlCarousel>
    );
};

export default VerticalSlider;